import { Badge, Button, Grid, Menu, MenuItem, Paper } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import FilterListIcon from '@material-ui/icons/FilterList';
import RefreshIcon from '@material-ui/icons/Refresh';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  mainWrapper: {
    paddingTop: '18px',
    paddingBottom: '18px',
    paddingLeft: '24px',
    paddingRight: '24px',
  },
  ttitle: {
    alignSelf: 'center',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '-0.05px',
  },
  refreshButton: {
    alignSelf: 'center',
  },
  filterOptions: {
    padding: '16px',
  },
  selectedIcon: {
    padding: '16px 16px 0px 16px !important',
  },
  menuItem: {
    borderBottom: '1px solid #727272',
    flexWrap: 'nowrap',
  },
  badge: {
    backgroundColor: '#FFC107',
    color: 'black',
  },
  filterButton: {
    cursor: 'pointer',
  },
  menuWrapper: {
    padding: '0px 12px',
  },
  menuItemWrapper: {
    borderBottom: '1px solid rgba(33, 33, 33, 0.08)',
    padding: '8px 8px',
  },
}));

export function ActionBarComponent({
  useFilter = false,
  filterOptions = [], // static array of filtyer config
  activeFilter = {}, // dynamic data to manupulate UI.

  onRefreshClick = () => {},
  onFilterClick = () => {},
  onFilterSelection = () => {},
}) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleFilterClick = event => {
    // open dropdown
    onFilterClick();
    setAnchorEl(event.currentTarget);
  };

  const handleRefreshClick = () => {
    onRefreshClick();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleFilterOptionSelect = payload => {
    onFilterSelection(payload);
    setAnchorEl(null);
  };

  return (
    <>
      <Paper className={`${classes.mainWrapper}`} elevation={1}>
        <Grid
          container
          className={classes.actionContainer}
          justify="space-between"
          alignContent="center"
        >
          <Grid item className={`${classes.actionItem} ${classes.ttitle}`}>
            Video Files
          </Grid>
          <Grid item className={`${classes.actionItem}`}>
            <Grid container spacing={3}>
              <Grid item className={`${classes.refreshButton}`}>
                <Button startIcon={<RefreshIcon />} color="primary" onClick={handleRefreshClick}>
                  Refresh Table
                </Button>
              </Grid>
              {useFilter ? (
                <Grid item className={`${classes.filterButton}`} onClick={handleFilterClick}>
                  <Badge
                    badgeContent={1}
                    color="primary"
                    classes={{
                      badge: classes.badge,
                    }}
                  >
                    <FilterListIcon />
                  </Badge>
                </Grid>
              ) : null}

              {filterOptions && filterOptions.length > 0 && (
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  className={classes.filterOptions}
                  classes={{
                    paper: classes.menuWrapper,
                  }}
                >
                  {filterOptions.map((filter, index) => (
                    <MenuItem
                      key={index}
                      classes={{
                        root: classes.menuItemWrapper,
                      }}
                      onClick={() =>
                        handleFilterOptionSelect({
                          payload: filter,
                        })
                      }
                    >
                      <Grid
                        container
                        spacing={4}
                        justify="space-between"
                        className={classes.menuItem}
                      >
                        <Grid item>{filter.uiText}</Grid>
                        <Grid
                          item
                          classes={{
                            item: classes.selectedIcon,
                          }}
                        >
                          {activeFilter.id === filter.id && <CheckIcon color="primary" />}
                        </Grid>
                      </Grid>
                    </MenuItem>
                  ))}
                </Menu>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}
